var getBlocksBefore = function getBlocksBefore(block, blockMap) {
  return blockMap.takeUntil(function (vBlock) {
    return (vBlock === null || vBlock === void 0 ? void 0 : vBlock.getKey()) === block.getKey();
  });
};

export default getBlocksBefore;